"use strict";
// import { ButtonControl, NewDropdownControl, TextInputControl } from "doshx_controls_web";
// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { IAuctionSliceState, setAuctions } from "../../../reducers/slices/auction";
// import { setMessageModal, setContentModal } from "../../../reducers/slices/main";
// import { IConsoleSliceState } from "../../../reducers/slices/console";
// import { unregistered_bidders_for_client } from "../../../api/calls/bidder/v3/unregistered_bidders_for_client";
// import { IClientSliceState } from "../../../reducers/slices/client";
// import { register_bidder } from "../../../api/calls/bidder/v3/register_bidder";
// import { get_all_auctions } from "../../../api/calls/auction/v3/get_all_auctions";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterBidderScreen = void 0;
// const RegisterBidderScreen = ({ refreshUsers }) => {
//   const dispatch = useDispatch();
//   const { selectedClient } = useSelector<any, IClientSliceState>((state) => state.clientState);
//   const { auctions } = useSelector<any, any>((state) => state.auctionState);
//   const [registeredUsers, setRegisteredUsers] = useState<any[]>([]);
//   const [selectedUser, setSelectedUser] = useState<any>(null);
//   const [idNumber, setIDNumber] = useState("");
//   const [address, setAddress] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [selectedAuction, setSelectedAuction] = useState<any>(null);
//   const [page, setPage] = useState(1);
//   const [limit] = useState(10);
//   const [hasMore, setHasMore] = useState(true);
//   useEffect(() => {
//     if (selectedClient) {
//       get_all_auctions(selectedClient.entity_id).then((response) => {
//         if (response.data.success) {
//           dispatch(setAuctions(response.data.content));
//         } else {
//           dispatch(setMessageModal({ title: "Error!", messages: [response.data.message] }));
//         }
//       });
//     }
//   }, [selectedClient]);
//   useEffect(() => {
//     if (!selectedClient?.entity_id) return;
//     setIsLoading(true);
//     unregistered_bidders_for_client(selectedClient.entity_id, { page, limit }).then((response) => {
//       setIsLoading(false);
//       if (response.data.success) {
//         const data = response.data.content.users;
//         if (page === 1) {
//           setRegisteredUsers(data);
//         } else {
//           setRegisteredUsers((prev) => [...prev, ...data]);
//         }
//         if (data.length < limit) {
//           setHasMore(false);
//         } else {
//           setHasMore(true);
//         }
//       } else {
//         dispatch(setMessageModal({ title: "Something went wrong!", messages: [response.data.message] }));
//       }
//     });
//   }, [selectedClient?.entity_id, page]);
//   useEffect(() => {
//     setPage(1);
//     setHasMore(true);
//     setRegisteredUsers([]);
//   }, [selectedClient?.entity_id]);
//   const handleAuctionChange = (selectedOption) => {
//     const auction = auctions.find((a) => a.entity_id === selectedOption.value);
//     if (auction) {
//       setSelectedAuction(auction);
//     }
//   };
//   return (
//     <div className="flex flex-col gap-4">
//       <NewDropdownControl
//         label="Select Auction"
//         value={
//           selectedAuction
//             ? { value: selectedAuction.entity_id, label: selectedAuction.title }
//             : null
//         }
//         options={auctions.map((auction) => ({
//           value: auction.entity_id,
//           label: auction.title,
//         }))}
//         onChange={handleAuctionChange}
//         renderDisplay={(item) => item.label}
//         colors={{ borderColor: "border-black", labelColor: "text-black" }}
//       />
//       <div
//         className="overflow-y-auto border border-gray-300 h-[200px] rounded"
//         onScroll={(e) => {
//           const target = e.target as HTMLDivElement;
//           if (
//             target.scrollHeight - target.scrollTop - target.clientHeight < 100 &&
//             hasMore &&
//             !isLoading
//           ) {
//             console.log("Load next page...");
//             setPage((prev) => prev + 1);
//           }
//         }}
//       >
//         {registeredUsers.map((user) => (
//           <div
//             key={user.entity_id}
//             className={`p-2 border-b cursor-pointer ${
//               selectedUser?.entity_id === user.entity_id ? "bg-blue-100" : ""
//             }`}
//             onClick={() => setSelectedUser(user)}
//           >
//             {user.name} {user.surname}
//           </div>
//         ))}
//         {isLoading && (
//           <div className="p-2 text-center text-gray-500">Loading...</div>
//         )}
//         {!hasMore && (
//           <div className="p-2 text-center text-gray-400">No more users</div>
//         )}
//       </div>
//       <div className="flex flex-col gap-4">
//         <TextInputControl
//           label="ID Number"
//           value={idNumber}
//           onChange={setIDNumber}
//         />
//         <TextInputControl
//           label="Address"
//           value={address}
//           onChange={setAddress}
//         />
//       </div>
//       <ButtonControl
//         label="Register Bidder"
//         loading={isLoading}
//         onClick={() => {
//           if (!selectedUser || !selectedAuction) {
//             dispatch(
//               setMessageModal({
//                 title: "Error",
//                 messages: ["Select a user and auction first!"],
//               })
//             );
//             return;
//           }
//           const auctionPhone = selectedAuction.contact_details?.phone;
//           const cell_phone = {
//             country_code: auctionPhone?.country_code || "ZA",
//             calling_code: auctionPhone?.calling_code || "+27",
//             number: auctionPhone?.number || "000000000",
//           };
//           setIsLoading(true);
//           register_bidder({
//             id_number: idNumber,
//             address: address,
//             bidder: {
//               client_entity_id: selectedClient.entity_id,
//               user_entity_id: selectedUser.entity_id,
//               registered_auction_id: selectedAuction.entity_id,
//             },
//             fullname: `${selectedUser.name} ${selectedUser.surname}`,
//             email: selectedUser.email,
//             cell_phone,
//           }).then((response) => {
//             setIsLoading(false);
//             if (response.data.success) {
//               refreshUsers();
//               dispatch(setContentModal(null));
//             } else {
//               dispatch(
//                 setMessageModal({
//                   title: "Something went wrong!",
//                   messages: [response.data.message],
//                 })
//               );
//             }
//           });
//         }}
//       />
//     </div>
//   );
// };
// export { RegisterBidderScreen };
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var auction_1 = require("../../../reducers/slices/auction");
var main_1 = require("../../../reducers/slices/main");
var unregistered_bidders_for_client_1 = require("../../../api/calls/bidder/v3/unregistered_bidders_for_client");
var register_bidder_1 = require("../../../api/calls/bidder/v3/register_bidder");
var get_all_auctions_1 = require("../../../api/calls/auction/v3/get_all_auctions");
var user_sign_up_1 = require("../../../api/calls/users/user_sign_up");
var RegisterBidderScreen = function (props) {
    var refreshUsers = props.refreshUsers;
    var dispatch = (0, react_redux_1.useDispatch)();
    var mainAuction = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).mainAuction;
    var selectedClient = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).selectedClient;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var auctions = (0, react_redux_1.useSelector)(function (state) { return state.auctionState; }).auctions;
    var _a = (0, react_1.useState)([]), registeredUsers = _a[0], setRegisteredUsers = _a[1];
    var _b = (0, react_1.useState)(), selectedUser = _b[0], setSelectedUser = _b[1];
    var _c = (0, react_1.useState)(""), idNumber = _c[0], setIDNumber = _c[1];
    var _d = (0, react_1.useState)(""), address = _d[0], setAddress = _d[1];
    var _e = (0, react_1.useState)(""), name = _e[0], setName = _e[1];
    var _f = (0, react_1.useState)(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = (0, react_1.useState)(null), selectedAuction = _g[0], setSelectedAuction = _g[1];
    var _h = (0, react_1.useState)(1), page = _h[0], setPage = _h[1];
    var limit = (0, react_1.useState)(10)[0];
    var _j = (0, react_1.useState)(""), email = _j[0], setEmail = _j[1];
    var _k = (0, react_1.useState)({
        country_code: "ZA",
        calling_code: "+27",
        number: "",
    }), cell_phone = _k[0], setCellPhone = _k[1];
    var _l = (0, react_1.useState)("ZA"), cc = _l[0], setCC = _l[1];
    var _m = (0, react_1.useState)(""), ext = _m[0], setExt = _m[1];
    (0, react_1.useEffect)(function () {
        if (selectedClient) {
            (0, get_all_auctions_1.get_all_auctions)(selectedClient.entity_id).then(function (response) {
                if (response.data.success) {
                    (0, auction_1.setAuctions)(response.data.content);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong while getting archived auctions!", messages: [response.data.message] }));
                }
            });
        }
    }, [selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.entity_id]);
    (0, react_1.useEffect)(function () {
        if (selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.entity_id) {
            (0, unregistered_bidders_for_client_1.unregistered_bidders_for_client)(selectedClient.entity_id, { page: page, limit: limit }).then(function (response) {
                if (response.data.success) {
                    //           console.log("response.data.content", response.data.content);
                    setRegisteredUsers(response.data.content.users);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.data.message] }));
                }
            });
        }
    }, [selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.entity_id]);
    var handleAuctionChange = function (selectedOption) {
        var auction = auctions.find(function (a) { return a.entity_id === selectedOption.value; });
        if (auction) {
            setSelectedAuction(auction);
            // Only call API if client is selected
            // if (selectedClient?.entity_id) {
            //   bidders_for_client({
            //     client_entity_id: selectedClient.entity_id,
            //     auction_entity_id: auction.entity_id,
            //   }).then((response) => {
            //     if (response.data.success) {
            //       setRegisteredUsers(response.data.content);
            //     } else {
            //       dispatch(setMessageModal({ title: "Failed to get bidders!", messages: [response.data.message] }));
            //     }
            //   }).catch((err) => {
            //     console.error("API error:", err);
            //   });
            // }
        }
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" },
            react_1.default.createElement(doshx_controls_web_1.NewDropdownControl, { label: "Select Auction", value: selectedAuction ? { value: selectedAuction.entity_id, label: selectedAuction.title } : null, options: auctions.map(function (auction) { return ({
                    value: auction.entity_id,
                    label: auction.title,
                }); }), onChange: handleAuctionChange, renderDisplay: function (item) { return item.label; }, colors: {
                    borderColor: "border-black",
                    labelColor: "text-black",
                } })),
        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Name", value: name, onChange: function (v) {
                setName(v);
            } }),
        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", value: email, onChange: function (v) {
                setEmail(v);
            } }),
        react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Phone Number", value: cell_phone.number, defaultCountryCode: cc, size: "medium", onChange: function (v) {
                setCellPhone(function (prev) { return (__assign(__assign({}, prev), { number: v })); });
            }, onExtensionChange: function (ext, cc) {
                setCellPhone(function (prev) { return (__assign(__assign({}, prev), { country_code: cc, calling_code: ext })); });
            } }),
        react_1.default.createElement("div", { className: "flex flex-col gap-4" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "ID Number", value: idNumber, onChange: function (v) {
                    setIDNumber(v);
                } }),
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Address", value: address, onChange: function (v) {
                    setAddress(v);
                } })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Register Bidder", loading: isLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var auctionPhone, cell_phone;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                auctionPhone = (_a = selectedAuction.contact_details) === null || _a === void 0 ? void 0 : _a.phone;
                                cell_phone = {
                                    country_code: (auctionPhone === null || auctionPhone === void 0 ? void 0 : auctionPhone.country_code) || "ZA",
                                    calling_code: (auctionPhone === null || auctionPhone === void 0 ? void 0 : auctionPhone.calling_code) || "+27",
                                    number: (auctionPhone === null || auctionPhone === void 0 ? void 0 : auctionPhone.number) || "000000000"
                                };
                                setIsLoading(true);
                                return [4 /*yield*/, (0, user_sign_up_1.sign_up)({
                                        client_entity_id: selectedClient.entity_id,
                                        name: name,
                                        // surname: user?.surname ?? "",
                                        email: email,
                                        cell_phone: cell_phone,
                                        // password: user?.password ?? "",
                                        // get_communication: user?.get_communication ?? false,
                                        // agrees_terms_and_conditions: user?.agrees_terms_and_conditions ?? false,
                                    }).then(function (response) {
                                        var _a, _b, _c;
                                        setIsLoading(false);
                                        if (response.data.success) {
                                            //                     console.log("resgistetete",response.data)
                                            (0, register_bidder_1.register_bidder)({
                                                id_number: idNumber,
                                                address: address,
                                                fullname: name,
                                                email: email,
                                                bidder: {
                                                    client_entity_id: selectedClient.entity_id,
                                                    user_entity_id: (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.entity_id,
                                                    registered_auction_id: selectedAuction.entity_id
                                                },
                                                // fullname: `${selectedUser.name} ${selectedUser.surname}`,
                                                cell_phone: cell_phone,
                                            }).then(function (response) {
                                                setIsLoading(false);
                                                if (response.data.success) {
                                                    //                         console.log("response.data.content", response.data.content);
                                                    refreshUsers();
                                                    dispatch((0, main_1.setContentModal)(null));
                                                }
                                                else {
                                                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.data.message] }));
                                                }
                                            });
                                            dispatch((0, main_1.setContentModal)(null));
                                        }
                                        else {
                                            dispatch((0, main_1.setContentModal)(null));
                                            dispatch((0, main_1.setMessageModal)({ title: "Bidder registered!", messages: ["Bidder is already registered"] }));
                                        }
                                        ;
                                    })];
                            case 1:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                }); } }))));
};
exports.RegisterBidderScreen = RegisterBidderScreen;
